/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import _ from 'lodash';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import EditorContainer from '../../../../SharedModules/AdvanceTextEditor';
import LetterTemplateTableGrid from './gridComponents/LtTableGrid';
import { letterTemplateHead } from './gridComponents/LtTableHead';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import LTCommonModal from './gridComponents/LTCommonModal';
import {
  freeFromText,
  windowAddressIndicatorError,
  maintainLetterTemplate,
  selectMergeFieldOptionsError,
  mergeFieldError,
  isPageNumberDisplayName,
  htmlHasPageNumberMergeField,
} from './gridComponents/ConstantData';
import {
  MERGE_FIELD_ITEM_REQUIRED,
  ONLY_ONE_FREE_FROM_TEXT,
  NOT_ANY_SELECTED_MERGE_FIELD,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  convertHTMLtoBlockmap,
  convertBlockmaptoHTML,
  getRandomNumberByInput,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  updateAllSubMergeField,
  saveLetterTemplateDetailList,
  saveLTDMergeFieldList,
  getAllSubMergeFieldListData,
} from '../store/actions';

function LTHeaderFooterTab(props) {
  const {
    isEnableSave,
    isSaveOpen,
    isEnableCancel,
    isCancelOpen,
    mainFilterValue,
    setStateChange,
    setErrorStateChange,
    isEnablebyRole,
  } = props;
  const gridRef = React.useRef();
  const dispatch = useDispatch();

  const letterTemplateDetail = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.letterTemplateDetail
  );
  const letterTemplateDetailPage = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.letterTemplateDetail.searchValue
  );
  const deletedMF = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState.deleteMF
  );
  const MFList = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.letterTemplateDetail
        .templateDetails
  );
  const allSelectedMergeField = useSelector(
    (state) => state?.sharedState?.LetterTemplateReducer?.allSelectedMergeField
  );
  const allMergeFieldListForDefaultFooter = useSelector(
    (state) =>
      state?.sharedState?.LetterTemplateReducer
        ?.allMergeFieldListForDefaultFooter
  );
  const detailTabErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.detailTab
  );

  const setFilterValueAction = (value) =>
    dispatch(saveLetterTemplateDetailList(value));
  const getSubMergeFieldList = (value) =>
    dispatch(getAllSubMergeFieldListData(value));

  const letterTemplateDetailRef = React.useRef(letterTemplateDetail);
  letterTemplateDetailRef.current = letterTemplateDetail;

  const [loading, setLoading] = React.useState(true);
  const [totalResultCount, setTotalResultCount] = React.useState(0);
  const [viewMergeFieldList, setViewMergeFieldList] = React.useState(false);
  const [mergeFor, setMergeFor] = React.useState(null);
  const [selectedMergeField, setSelectedMergeField] = React.useState([]);
  const [selectedSubMergeField, setSelectedSubMergeField] = React.useState([]);
  const [addHeaderInput, setAddHeaderInput] = React.useState([]);
  const [deleteHeaderInput, setDeleteHeaderInput] = React.useState([]);
  const [addFooterInput, setAddFooterInput] = React.useState([]);
  const [deleteFooterInput, setDeleteFooterInput] = React.useState([]);
  const [deleteList, setDeleteList] = React.useState([]);
  const [pageView, setPageView] = React.useState(null);
  const [isError, setIsError] = React.useState(false);
  const [errorModalTitle, setErrorModalTitle] = React.useState('Warning');
  const [isErrorMsg, setIsErrorMsg] = React.useState(null);
  const [headerData, setHeaderData] = React.useState(null);
  const [footerData, setFooterData] = React.useState(null);
  const [isDefaultFooterData, setIsDefaultFooterData] = React.useState(false);
  const [htmlTextHeader, setHtmlTextHeader] = React.useState([]);
  const [htmlTextFooter, setHtmlTextFooter] = React.useState([]);
  const [editHeaderMergeField, setEditHeaderMergeField] = React.useState([]);
  const [editFooterMergeField, setEditFooterMergeField] = React.useState([]);

  const [defaultFooterMFDList, setDefaultFooterMFDList] = React.useState([]);
  // Keep latest selected merge fields for rebuild without putting them in effect deps
  // (avoids clear→rebuild loops; same pattern as Body tab).
  const allSelectedMergeFieldRef = React.useRef(allSelectedMergeField);
  allSelectedMergeFieldRef.current = allSelectedMergeField;

  // Onload of the Header Footer component
  const onChangeMergeFieldRedux = (data) => {
    setFilterValueAction({
      ...letterTemplateDetail,
      ...data,
    });
  };

  // This just get new update data from redux to useState
  React.useEffect(() => {
    setLoading(false);
  }, [letterTemplateDetailPage]);

  React.useEffect(() => {
    if (letterTemplateDetailPage && !_.isEmpty(letterTemplateDetailPage)) {
      setHeaderData(letterTemplateDetailPage.header);
    }
  }, [letterTemplateDetailPage.header, letterTemplateDetailPage.templateVersion]);

  React.useEffect(() => {
    if (letterTemplateDetailPage && !_.isEmpty(letterTemplateDetailPage)) {
      setFooterData(letterTemplateDetailPage.footer);
    }
  }, [letterTemplateDetailPage.footer, letterTemplateDetailPage.templateVersion]);

  React.useEffect(() => {
    let newList = [];
    if (!_.isEmpty(deletedMF)) {
      newList = [...deletedMF];
      if (!_.isEmpty(htmlTextHeader) || !_.isEmpty(htmlTextFooter)) {
        if (JSON.stringify(deleteList) !== JSON.stringify(newList)) {
          const headerData1 = [];
          const footerData1 = [];
          const list = _.filter(newList, (val) => {
            if (_.includes(htmlTextHeader, val.displayName)) {
              headerData1.push(val);
            } else if (_.includes(htmlTextFooter, val.displayName)) {
              footerData1.push(val);
            } else {
              return val;
            }
          });
          setDeleteList(list);
          setStateChange({ deleteMF: list });
          setDeleteHeaderInput(headerData1);
          setDeleteFooterInput(footerData1);
        }
      }
    }
  }, [deletedMF, htmlTextHeader, htmlTextFooter]);

  // Rebuild header/footer selected merge fields from editor tokens + templateDetails.
  // Must re-run when templateDetails change after save (Body already did this).
  // Previously only depended on htmlText* / a mutated selectedData ref, so after save
  // cleared allSelectedMergeField the Header/Footer lists stayed empty/stale.
  React.useEffect(() => {
    const hasHeaderTokens = !_.isEmpty(htmlTextHeader);
    const hasFooterTokens = !_.isEmpty(htmlTextFooter);
    if (!hasHeaderTokens && !hasFooterTokens) {
      return;
    }
    if (
      _.isEmpty(letterTemplateDetail) ||
      _.isEmpty(letterTemplateDetail?.templateDetails)
    ) {
      return;
    }

    const buildSelectedForTokens = (htmlTextNew) => {
      if (_.isEmpty(htmlTextNew)) {
        return null;
      }
      const data = [];
      htmlTextNew.forEach((item) => {
        const res = item.replace(/[0-9]/g, '');
        _.filter([...letterTemplateDetail.templateDetails], (i) => {
          // Match Body tab: displayName only (do not require seqNum/templateId),
          // so lists rebuild correctly right after save assigns new seq nums.
          if (item === i?.displayName) {
            const otherData = !_.isEmpty(allMergeFieldListForDefaultFooter)
              ? _.filter(
                  allMergeFieldListForDefaultFooter,
                  (l) => l.description === res
                )
              : [];
            if (!_.isEmpty(otherData)) {
              i.description = otherData[0].description;
              i.templateMetaDataSeqNum = otherData[0].templateMetaDataSeqNum;
              i.displayOrder = otherData[0].displayOrder;
              i.tempDatailItems = !_.isEmpty(i.tempDatailItems)
                ? _.map(i.tempDatailItems, (v) => ({
                    ...v,
                    isSelected: true,
                  }))
                : [];
              data.push(i);
            }
          }
          return i;
        });
      });
      let data1 = _.uniqBy(data, 'displayName');
      data1 = _.filter(data1, ['tempDetRemoved', false]);
      return data1;
    };

    const header = buildSelectedForTokens(htmlTextHeader);
    const footer = buildSelectedForTokens(htmlTextFooter);
    const prev = allSelectedMergeFieldRef.current || {};
    const patch = { ...prev };

    if (header !== null && (header.length > 0 || _.isEmpty(prev.header))) {
      patch.header = header;
    }
    if (footer !== null && (footer.length > 0 || _.isEmpty(prev.footer))) {
      patch.footer = footer;
    }

    const headerUnchanged = _.isEqual(prev.header, patch.header);
    const footerUnchanged = _.isEqual(prev.footer, patch.footer);
    if (headerUnchanged && footerUnchanged) {
      return;
    }

    dispatch(saveLTDMergeFieldList(patch));
  }, [
    htmlTextHeader,
    htmlTextFooter,
    letterTemplateDetail,
    allMergeFieldListForDefaultFooter,
  ]);

  React.useEffect(() => {
    const detail = letterTemplateDetailRef.current;
    if (!detail?.templateDetails?.length) return;

    const extractTokens = (editorState, page) => {
      if (!editorState) return null;
      try {
        const htmlData = convertBlockmaptoHTML(editorState);
        const tokens = new Set(htmlData.match(/[^{}]+(?=})/g) || []);
        if (htmlHasPageNumberMergeField(htmlData)) {
          (detail.templateDetails || []).forEach((l) => {
            if (
              l.page === page &&
              !l.tempDetRemoved &&
              isPageNumberDisplayName(l.displayName)
            ) {
              tokens.add(l.displayName);
            }
          });
        }
        return tokens;
      } catch (e) {
        return null;
      }
    };

    const headerTokens = extractTokens(letterTemplateDetailPage?.header, 'header');
    const footerTokens = extractTokens(letterTemplateDetailPage?.footer, 'footer');
    if (!headerTokens && !footerTokens) return;

    const mfd = _.cloneDeep(detail.templateDetails);
    let changed = false;
    mfd.forEach((l) => {
      if (l.page === 'header' && headerTokens) {
        if (!headerTokens.has(l.displayName) && !l.tempDetRemoved) {
          l.tempDetRemoved = true;
          if (!_.isEmpty(l.tempDatailItems)) {
            l.tempDatailItems.forEach((li) => {
              li.tempdItemRemoved = true;
            });
          }
          changed = true;
        }
      }
      if (l.page === 'footer' && footerTokens) {
        if (!footerTokens.has(l.displayName) && !l.tempDetRemoved) {
          l.tempDetRemoved = true;
          if (!_.isEmpty(l.tempDatailItems)) {
            l.tempDatailItems.forEach((li) => {
              li.tempdItemRemoved = true;
            });
          }
          changed = true;
        }
      }
    });
    if (changed) {
      setFilterValueAction({
        ...detail,
        templateDetails: mfd,
      });
    }
  }, [letterTemplateDetailPage?.header, letterTemplateDetailPage?.footer]);

  const removeSuccessMsg = () => {
    let errorMsg = detailTabErrorMessages;
    if (!_.isEmpty(errorMsg)) {
      errorMsg = _.filter(errorMsg, (l) => l.id !== 'sucessMsg');
    }
    setErrorStateChange({ detailPage: _.uniqBy(errorMsg, 'id') });
  };

  const filterAction = React.useCallback(
    (flType, value) => {
      dispatch(
        saveLetterTemplateDetailList({
          ...letterTemplateDetail,
          searchValue: {
            ...letterTemplateDetailPage,
            [flType]: value,
          },
        })
      );
      removeSuccessMsg();
      setStateChange({ edit: true });
    },
    [letterTemplateDetail, letterTemplateDetailPage]
  );

  const onClickMergeFieldAction = (flType) => {
    setLoading(true);
    setPageView('allMergeField');
    setViewMergeFieldList(true);
    dispatch(updateAllSubMergeField([]));
    // dispatch(getAllMergeFieldList({ templateTypeCd: ['ALL', 'COVER'] }));
    setMergeFor(flType);
  };

  const editMergeFieldAction = (flType) => {
    let openError = true;
   
    let dataList = allSelectedMergeField?.[flType];
    if (_.isEmpty(dataList)) {
      dataList = _.filter(
        MFList || [],
        (l) => !l.tempDetRemoved && l.page === flType
      );
    }
    if (!_.isEmpty(dataList)) {
      if (flType === 'header') {
        setEditHeaderMergeField(dataList);
      }
      if (flType === 'footer') {
        setEditFooterMergeField(dataList);
      }

      setMergeFor(flType);
      setPageView('updateMergeField');
      dispatch(updateAllSubMergeField([]));
      setViewMergeFieldList(true);
      openError = false;
    }
    if (openError && !isEnableSave) {
      setIsError(true);
      setIsErrorMsg(NOT_ANY_SELECTED_MERGE_FIELD);
    }
  };

  const onSelectMergeRow = (e) => {
    if (!_.isEmpty(e.mergeField)) {
      const mfd = _.uniqBy([...e.mergeField], 'templateMetaDataSeqNum');
      setSelectedMergeField(mfd);
    }
  };

  const onSelectSubMergeRow = (e) => {
    let selectedRow = e.selectedRows;
    if (!_.isEmpty(e.selectedRows)) {
      selectedRow = _.filter(selectedRow, (l) => l.isSelected);
      // } else {
      //   setSelectedMergeField([]);
    }
    setSelectedSubMergeField(selectedRow);
  };

  const onClickOkMergeField = () => {
    const mfd = !_.isEmpty(MFList) ? [...MFList] : [];
    const checkMFD = _.filter(mfd, (l) => {
      const res = l.displayName.replace(/[0-9]/g, '');
      return res === freeFromText && !l.tempDetRemoved;
    });
    const checkContactAddress = _.filter(
      selectedMergeField,
      (l) => l.description === 'Contact Address'
    );
    if (
      !_.isEmpty(checkContactAddress) &&
      letterTemplateDetailPage?.windowAddrInd === 1
    ) {
      setIsError(true);
      setIsErrorMsg(windowAddressIndicatorError);
      setErrorModalTitle(maintainLetterTemplate);
      return;
    }
    let passFreeFromText = false;
    if (!_.isEmpty(checkMFD)) {
      const getSelected = _.filter(selectedMergeField, (l) => {
        const res1 = checkMFD[0].displayName.replace(/[0-9]/g, '');
        return l.description === res1;
      });
      passFreeFromText = !_.isEmpty(getSelected);
    }
    if (!passFreeFromText) {
      if (!_.isEmpty(selectedSubMergeField)) {
        const notAllMergeFld = _.filter(
          selectedMergeField,
          (l) =>
            l.description === 'Labelers' ||
            l.description === 'Selected Qtr Invoice Fields' ||
            l.description === 'Past Due Invoice Data'
        );
        if (!_.isEmpty(notAllMergeFld)) {
          setIsError(true);
          setIsErrorMsg(mergeFieldError);
          setErrorModalTitle(selectMergeFieldOptionsError);
          return;
        }
        selectedSubMergeField.forEach((item) => {
          item.tempdItemRemoved = false;
          return item;
        });
        const newMfd = _.map(selectedMergeField, (item) => {
          const ranNum = getRandomNumberByInput(1)[0];
          const list = _.isEmpty(mfd)
            ? []
            : _.filter(mfd, (l) => {
                if (l.displayName && l.displayName !== '') {
                  const res = l.displayName.replace(/[0-9]/g, '');
                  return res === item.description;
                }
              });
          const num = list.length + 1;
          item.key = ranNum;
          item.templateDetailSeqNum = null;
          item.displayName = `${item.description}${num}`;
          item.page = mergeFor;
          item.tempDetRemoved = false;
          item.tempDatailItems = !_.isEmpty(selectedSubMergeField)
            ? [...selectedSubMergeField]
            : [];
          mfd.push(item);
          return item;
        });
        if (mergeFor === 'header') {
          setAddHeaderInput(newMfd);
        }
        if (mergeFor === 'footer') {
          setAddFooterInput(newMfd);
        }
        setSelectedMergeField([]);
        setSelectedSubMergeField([]);
        onChangeMergeFieldRedux({
          templateDetails: mfd,
        });
        setViewMergeFieldList(false);
        setIsError(false);
        setIsErrorMsg(null);
        setEditHeaderMergeField([]);
        setEditFooterMergeField([]);
      } else {
        setIsError(true);
        setIsErrorMsg(MERGE_FIELD_ITEM_REQUIRED);
      }
    } else {
      setIsError(true);
      setIsErrorMsg(ONLY_ONE_FREE_FROM_TEXT);
    }
  };

  const onClickOkEditMergeField = () => {
    if (!_.isEmpty(selectedSubMergeField)) {
      const newSelSubMF = _.filter(selectedSubMergeField, (l) => l.isSelected);
      const mfd = !_.isEmpty(MFList) ? _.cloneDeep(MFList) : [];
      if (!_.isEmpty(newSelSubMF) && !_.isEmpty(mfd)) {
        mfd.forEach((item) => {
          const changeList = _.filter(
            selectedMergeField,
            (l) =>
              l.templateMetaDataSeqNum === item.templateMetaDataSeqNum &&
              l.templateDetailSeqNum === item.templateDetailSeqNum
          );
          if (!_.isEmpty(changeList)) {
            if (
              changeList[0].templateMetaDataSeqNum ===
              item.templateMetaDataSeqNum
            ) {
              const { tempDatailItems, ...rest } = item;
              Object.keys(rest).map((k) => {
                item[k] = changeList[0][k];
              });
              const newData = [];
              const tempDatailItems1 = _.filter(
                item.tempDatailItems,
                (it) =>
                  it.templateDetailItemSeqNum &&
                  it.templateDetailItemSeqNum !== '' &&
                  it.templateDetailSeqNum &&
                  it.templateDetailSeqNum !== ''
              );
              _.map(_.cloneDeep(tempDatailItems1), (it) => {
                const selSMF = _.filter(
                  selectedSubMergeField,
                  (val) => it.columnHeading === val.columnHeading
                );
                if (_.isEmpty(selSMF)) {
                  it.tempdItemRemoved = true;
                  it.isSelected = false;
                } else {
                  Object.keys(selSMF[0]).map((k) => {
                    it[k] = selSMF[0][k];
                  });
                  it.tempdItemRemoved = false;
                  it.isSelected = true;
                }
                newData.push(it);
                return it;
              });
              selectedSubMergeField.forEach((val) => {
                const selSMF1 = _.filter(
                  tempDatailItems,
                  (l) => l.columnHeading === val.columnHeading
                );
                if (_.isEmpty(selSMF1)) {
                  val.tempdItemRemoved = false;
                  newData.push(val);
                  item.tempDatailItems.push(val);
                }
              });
              item.tempDatailItems = _.filter(newData, (l) => l.columnName);
            }
          }
          return item;
        });
        setSelectedSubMergeField([]);
        onChangeMergeFieldRedux({
          templateDetails: mfd,
        });
        setViewMergeFieldList(false);
        setIsError(false);
        setIsErrorMsg(null);
        setEditHeaderMergeField([]);
        setEditFooterMergeField([]);
        setStateChange({ edit: true });
      } else {
        setIsError(true);
        setIsErrorMsg(MERGE_FIELD_ITEM_REQUIRED);
      }
    } else {
      setIsError(true);
      setIsErrorMsg(MERGE_FIELD_ITEM_REQUIRED);
    }
  };

  const onDeleteMergeOkAction = (row) => {
    if (!_.isEmpty(MFList)) {
      // cloneDeep keeps templateDetailSeqNum on the deleted row for save payload
      let mfd = _.cloneDeep(MFList);
      mfd = _.map(mfd, (l) => {
        if (
          l.key === row.key &&
          l.templateMetaDataSeqNum === row.templateMetaDataSeqNum &&
          l.displayName === row.displayName
        ) {
          l.tempDetRemoved = true;
          if (!_.isEmpty(l.tempDatailItems)) {
            l.tempDatailItems.forEach((li) => {
              li.tempdItemRemoved = true;
            });
          }
        }
        return l;
      });
      if (!row.templateDetailSeqNum) {
        const getAllList = _.filter(
          mfd,
          (al) => al.description === row.description && !al.templateDetailSeqNum
        );
        const getAllListMap = _.map(getAllList, (ml) => {
          const res = ml.displayName.replace(/[a-zA-Z- ]/g, '');
          return {
            displayName: ml.displayName,
            posNum: _.trim(res),
          };
        });
        const getLetestList = _.maxBy(getAllListMap, 'posNum');
        if (!_.isEmpty(getLetestList)) {
          if (getLetestList.displayName === row.displayName) {
            mfd = _.filter(mfd, (l) => l.key !== row.key);
          }
        }
      }
      // Always persist so saveLetterTemplate gets tempDetRemoved + templateDetailSeqNum
      // and saveLetterTemplateDetailItem gets tempdItemRemoved on sub-items.
      onChangeMergeFieldRedux({
        templateDetails: mfd,
      });
      let mfg = _.filter(
        MFList,
        (l) => l.displayName === row.displayName
      );
      mfg = _.concat([...deletedMF], [...mfg]);
      setStateChange({ deleteMF: mfg });
    }
  };

  const getTextFromHtml = React.useCallback((flType, htmlText) => {
    if (flType === 'header') {
      setHtmlTextHeader(htmlText);
    }
    if (flType === 'footer') {
      setHtmlTextFooter(htmlText);
    }
  }, []);

  const getAllSubMergeFieldList = async (mfData, smfl) => {
    const newSMF = [];
    if (mfData && !_.isEmpty(mfData)) {
      const SMF = await Promise.resolve(
        getSubMergeFieldList({
          templateMetaDataSeqNum: mfData.templateMetaDataSeqNum,
        })
      );
      if (SMF && !_.isEmpty(SMF)) {
        SMF.forEach((item) => {
          item.tempdItemRemoved = false;
          if (item.templateMetaDataItemSeqNum === smfl) {
            newSMF.push(item);
          }
          return item;
        });
      }
    }
    return newSMF;
  };

  const getAllMergeFieldListInRedux = React.useCallback(
    async (count, arryArg) => {
      const mfd = !_.isEmpty(MFList) ? [...MFList] : [];
      if (count < arryArg.length) {
        const item = arryArg[count];
        const ranNum = getRandomNumberByInput(1)[0];
        const list = _.isEmpty(mfd)
          ? []
          : _.filter(mfd, (l) => {
              if (l.displayName && l.displayName !== '') {
                const res = l.displayName.replace(/[0-9]/g, '');
                return res === item.description;
              }
            });
        const num =
          (item.templateMetaDataSeqNum === 7 && count === 2) ||
          item.templateMetaDataSeqNum === 5 ||
          item.templateMetaDataSeqNum === 12
            ? list.length + 2
            : list.length + 1;
        item.key = ranNum;
        item.displayName = `${item.description}${num}`;
        item.page = 'footer';
        item.tempDetRemoved = false;
        let selectedSMF = 0;
        if (item.templateMetaDataSeqNum === 7) {
          selectedSMF = count === 2 ? 19 : 18;
        }
        if (item.templateMetaDataSeqNum === 12) {
          selectedSMF = 40;
        }
        if (item.templateMetaDataSeqNum === 5) {
          selectedSMF = 8;
        }
        if (selectedSMF !== 0) {
          const SMF = await getAllSubMergeFieldList(item, selectedSMF);
          if (SMF && !_.isEmpty(SMF)) {
            item.tempDatailItems = !_.isEmpty(SMF) ? SMF : [];
            arryArg[count] = item;
            getAllMergeFieldListInRedux(count + 1, arryArg);
          }
        }
      }
      if (count === arryArg.length) {
        setDefaultFooterMFDList(arryArg);
      }
    },
    []
  );

  const addDefaultHeader = React.useCallback(() => {
    setStateChange({ addDefHeader: true, edit: true });
  }, []);

  const addDefaultFooter = React.useCallback(() => {
    // filterAction('footer', '');
    setStateChange({ edit: true });
    if (
      allMergeFieldListForDefaultFooter &&
      !_.isEmpty(allMergeFieldListForDefaultFooter)
    ) {
      let MFL = _.filter(allMergeFieldListForDefaultFooter, (l) =>
        _.includes([7, 12, 5], l.templateMetaDataSeqNum)
      );
      let cloneMFL = _.filter(MFL, (r) => r.templateMetaDataSeqNum === 7);
      cloneMFL = _.cloneDeep(cloneMFL);
      MFL.push(cloneMFL[0]);
      if (MFL && !_.isEmpty(MFL)) {
        setLoading(true);
        MFL = _.orderBy(MFL, ['templateMetaDataSeqNum'], ['asc']);
        const newMFD = _.cloneDeep(MFL);
        getAllMergeFieldListInRedux(0, newMFD);
        setIsDefaultFooterData(true);
      }
    }
  }, [allMergeFieldListForDefaultFooter]);

  React.useEffect(() => {
    if (isDefaultFooterData && !_.isEmpty(defaultFooterMFDList)) {
      let mfd = !_.isEmpty(MFList) ? [...MFList] : [];
      if (!_.isEmpty(htmlTextFooter)) {
        mfd.forEach((l) => {
          const getFoo = _.filter(
            htmlTextFooter,
            (f) => l.displayName === f.displayName
          );
          if (!_.isEmpty(getFoo)) {
            l.tempDetRemoved = true;
            l.tempDatailItems.forEach((li) => {
              li.tempdItemRemoved = true;
              return li;
            });
          }
          return l;
        });
      }
      mfd = !_.isEmpty(mfd)
        ? _.concat([...mfd], [...defaultFooterMFDList])
        : [...defaultFooterMFDList];
      const mfrId = [];
      const mfrName = [];
      const invNo = [];
      const selQtr = [];
      _.map(defaultFooterMFDList, (item) => {
        const smf = item.tempDatailItems[0];
        if (item.templateMetaDataSeqNum === 7) {
          if (smf.templateMetaDataItemSeqNum === 19) {
            mfrId.push(item);
          }
          if (smf.templateMetaDataItemSeqNum === 18) {
            mfrName.push(item);
          }
        }
        if (
          item.templateMetaDataSeqNum === 12 &&
          smf.templateMetaDataItemSeqNum === 40
        ) {
          invNo.push(item);
        }
        if (
          item.templateMetaDataSeqNum === 5 &&
          smf.templateMetaDataItemSeqNum === 8
        ) {
          selQtr.push(item);
        }
      });
      const safeDisplay = (value) => {
        if (typeof value === 'string') return value;
        return '';
      };

      const newObj = {
        searchValue: {
          ...letterTemplateDetailPage,
          footer: convertHTMLtoBlockmap(
            `<p style="text-transform: capitalize;font-size: 12px; font-family: Arial">PLEASE RETURN THIS STUB WITH YOUR PAYMENT AND ATTACHMENTS</p><p style="font-size: 10px; font-family: Arial">Manufacturer:{${safeDisplay(
              mfrName?.[0]?.displayName
            )}}<br/>Manufacture ID : {${safeDisplay(
              mfrId?.[0]?.displayName
            )}}<br/>Invoice Number : {${safeDisplay(
              invNo?.[0]?.displayName
            )}}<br/>Quarter Billed : {${safeDisplay(
              selQtr?.[0]?.displayName
            )}}</p><p style="font-size: 10px; font-family: Arial">Rebate payments should be made payable to XXXXXXXXXX  and sent with the accompanying documentation (ROSI/PQAS) to:</p><p style="font-size: 10px; font-family: Arial">XXXXXXXXXX<br/>P.O. Box XXXXXX<br/>XXXXXXXXXX, XX XXXXX-XXXX</p><p style="font-size: 10px; font-family: Arial">Amount Paid : $___________</p>`
          ),
        },
        templateDetails: mfd,
      };
      onChangeMergeFieldRedux(newObj);
      setStateChange({ edit: true });
      setLoading(false);
      setIsDefaultFooterData(false);
    }
  }, [isDefaultFooterData, letterTemplateDetailPage, defaultFooterMFDList]);

  return (
    <div
      className="lettterTemplate p-0"
      data-testid="letter-template-search-component"
    >
      <Spinner load={loading} />
      <div className="tabs-container pl-0 pr-0">
        <div className="no-margin">
          {/* <div className="TemplateList">
            <LetterTemplateTableGrid
              gridRef={gridRef}
              cellHead={letterTemplateHead}
              dataList={
                MFList
                  ? _.orderBy(
                    _.filter([...MFList], (l) => l && !l.tempDetRemoved),
                    ['displayName'],
                    ['asc']
                  )
                  : []
              }
              gridHeight={200}
              fileName="Letter Template"
              setTotalResultCount={setTotalResultCount}
              previewOkModalAction={onDeleteMergeOkAction}
            />
            <p className="total-results">
              Total Results:
              <b>{totalResultCount}</b>
            </p>
          </div> */}

          <div className="btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                data-testid="default-footer"
                className="btn btn-cancel mb-1"
                disabled={
                  !isEnablebyRole ||
                  (letterTemplateDetailPage?.templateId
                    ? false
                    : letterTemplateDetailPage?.templateTypeCd !== 'COVER')
                }
                onClick={addDefaultHeader}
              >
                <SVGComponent iconName="Icon-outline-add-circle" />
                Default Header
              </Button>
            </div>
            <div className="clearfix" />

            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success"
                data-testid="merge-field"
                onClick={() => onClickMergeFieldAction('header')}
                disabled={!isEnablebyRole}
              >
                <SVGComponent iconName="Icon-outline-add-circle" /> Merge Field
              </Button>
              <Button
                className="btn btn-success"
                data-testid="cancelBtn"
                onClick={() => editMergeFieldAction('header')}
                disabled={!isEnablebyRole}
              >
                <SVGComponent iconName="Icon-outline-edit" />
                Merge Field
              </Button>
            </div>
            <div className="clearfix" />
          </div>
          <div className="TemplateInput">
            <EditorContainer
              data-testid="editorContainer"
              height="250px"
              insertData={addHeaderInput}
              deleteData={deleteHeaderInput}
              result={headerData}
              getTextFromHtml={(e) => getTextFromHtml('header', e)}
              filterAction={(e) => filterAction('header', e)}
              editorStateChange={(e) => setStateChange({ edit: true })}
              isEnablebyRole={isEnablebyRole}
            />
          </div>

          <div className="btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                data-testid="default-footer"
                className="btn btn-cancel mb-1"
                disabled={
                  !isEnablebyRole ||
                  (letterTemplateDetailPage?.templateId
                    ? false
                    : letterTemplateDetailPage?.templateTypeCd !== 'COVER')
                }
                onClick={addDefaultFooter}
              >
                <SVGComponent iconName="Icon-outline-add-circle" />
                Default Footer
              </Button>
            </div>
            <div className="clearfix" />

            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success"
                data-testid="merge-field2"
                onClick={() => onClickMergeFieldAction('footer')}
                disabled={!isEnablebyRole}
              >
                <SVGComponent iconName="Icon-outline-add-circle" /> Merge Field
              </Button>
              <Button
                className="btn btn-success"
                data-testid="cancelBtn2"
                onClick={() => editMergeFieldAction('footer')}
                disabled={!isEnablebyRole}
              >
                <SVGComponent iconName="Icon-outline-edit" />
                Merge Field
              </Button>
            </div>
            <div className="clearfix" />
          </div>

          <div className="TemplateInput">
            <EditorContainer
              data-testid="editorContainer2"
              height="250px"
              insertData={addFooterInput}
              deleteData={deleteFooterInput}
              result={footerData}
              getTextFromHtml={(e) => getTextFromHtml('footer', e)}
              filterAction={(e) => filterAction('footer', e)}
              editorStateChange={(e) => setStateChange({ edit: true })}
              isEnablebyRole={isEnablebyRole}
            />
          </div>
        </div>

        {viewMergeFieldList && (
          <CommonModal
            className="frr-dialog-css"
            data-testid="commonModal"
            open={viewMergeFieldList}
            viewAction
            viewHeader
            onOk={
              pageView === 'updateMergeField'
                ? onClickOkEditMergeField
                : onClickOkMergeField
            }
            okTitle="Update"
            onClose={() => {
              setEditHeaderMergeField([]);
              setEditFooterMergeField([]);
              setViewMergeFieldList(false);
            }}
            closeTitle="Cancel"
            modalTitle={`${
              pageView === 'updateMergeField' ? 'Update' : 'Select'
            } a Merge Field`}
            childrenComponent={
              <LTCommonModal
                closeModal={setViewMergeFieldList}
                setLoading={setLoading}
                pageView={pageView}
                editBodyMergeField={
                  mergeFor === 'header'
                    ? editHeaderMergeField
                    : mergeFor === 'footer'
                    ? editFooterMergeField
                    : []
                }
                selectedMergeField={selectedMergeField}
                onSelectMergeRow={onSelectMergeRow}
                onSelectSubMergeRow={onSelectSubMergeRow}
                selectedSubMergeField={selectedSubMergeField}
                mainFilterValue={mainFilterValue}
                setIsError={setIsError}
                setIsErrorMsg={setIsErrorMsg}
              />
            }
          />
        )}

        {isError && (
          <CommonModal
            className="dialog-420"
            open={isError}
            viewAction
            viewHeader
            onClose={() => setIsError(false)}
            closeTitle="Ok"
            modalTitle={errorModalTitle}
            childrenComponent={<div className="p-3">{isErrorMsg}</div>}
          />
        )}
      </div>
    </div>
  );
}

export default LTHeaderFooterTab;
